// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"938":"bc844e88","991":"793be600"}[chunkId] + ".js";
};